import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useMediaQuery } from '@material-ui/core';
import { deleteAllCookie } from 'src/utils/common.util';
import Routes from '../../modules/Navigator/Navigator.route';
import { useCookies } from 'react-cookie';

interface IProps {
  to: string;
  title: string;
  className?: string;
}

const NavLink: React.FC<IProps> = (props) => {
  const location = useLocation();
  const history = useHistory();
  const [, , removeCookie] = useCookies(['']);
  const matches = useMediaQuery('(max-width:768px)');
  const isIpadLg = useMediaQuery('(max-width:1024px)');
  const isTablet = matches || isIpadLg;

  const checkIsActive = () => {
    if (props.to === Routes.PatientDocument) {
      return ['patient-document', 'form-submission'].includes(
        location.pathname.split('/')[1]
      );
    }

    if (props.to === Routes.Dashboard) {
      return ['', '/', 'dashboard'].includes(location.pathname.split('/')[1]);
    }

    return location.pathname === props.to;
  };

  const isActive = checkIsActive();

  const handleNavigate = () => {
    if (props.to === Routes.SignIn) {
      removeCookie('userInfo');
      removeCookie('role');
      deleteAllCookie();
    }

    history.push(props.to);
  };

  return isTablet ? (
    <div
      onClick={handleNavigate}
      className={`navbar__navlink-item-mobile ${props.className}`}
    >
      <p
        className={`navbar__navlink-title-mobile ${
          isActive && 'navbar__navlink-title--active'
        }`}
      >
        {props.title}
      </p>
    </div>
  ) : (
    <div
      onClick={handleNavigate}
      className={`navbar__navlink-item ${props.className}`}
    >
      <p
        className={`navbar__navlink-title ${
          isActive && 'navbar__navlink-title--active'
        }`}
      >
        {props.title}
      </p>
      {isActive && <div className="navbar__active-dot" />}
    </div>
  );
};

export default NavLink;
